<template>
  <div class="search">
    <input
      type="text"
      v-model.trim="searchText"
      placeholder="请输入资源名称"
      @keyup.enter="handleQuery"
    />
    <div>
      <i class="el-icon-search" @click="handleQuery">搜索</i>
    </div>
  </div>
</template>

<script>
export default {
  name: "search",
  data() {
    return {
      searchText: "",
    };
  },
  methods: {
    handleQuery() {
      //如果搜索条件不为空跳转搜索结果页
      // if (this.searchText.replace(/^\s+|\s+$/g, "") != "") {
      console.log(this.$store.state.read);
      // this.$store.state.read.searchText = this.searchText;

      setTimeout(() => {
        this.$router.push({
          path: "/search/index",
          query: { text: this.searchText },
        });
        this.searchText = "";
      }, 100);
      // } else {
      //   this.$store.state.read.searchText = this.searchText;
      // }
    },
  },
};
</script>

<style scoped lang="scss">
.search {
  width: 650px;
  margin: 40px auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  input {
    width: 550px;
    height: 50px;
    background: #e5e5e5;
    border: none;
    outline: none;
    padding: 0 15px 0 15px;
    box-sizing: border-box;
  }
  .el-icon-search {
    background-color: #128bff;
    width: 100px;
    cursor: pointer;
    text-align: center;
    line-height: 48px;
    color: #fff;
    font-size: 18px;
    &:before {
      margin-right: 6px;
      font-size: 24px;
      position: relative;
      top: 2px;
    }
  }
}
</style>
